import React from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ActionButton, Icon } from 'ui'
import SettingsIcon from '/public/s2_icon_settings.svg'
import { useProjectActions } from '@hooks/useProject'

const SettingsActionButton = () => {
  const flags = useFlags()

  const { setShowSettingsDialog, setSelectedSettingsItem } = useProjectActions()

  function handleClick() {
    setSelectedSettingsItem('files')
    setShowSettingsDialog(true)
  }

  if (!flags['base-pf-ui-project-private-default']) return null
  return (
    <ActionButton onClick={handleClick}>
      <Icon slot="icon">
        <SettingsIcon />
      </Icon>
    </ActionButton>
  )
}

export default SettingsActionButton
